import React from "react";
import { Form, Button } from "react-bootstrap";
import { useState } from "react";
import api from "../../api/axiosConfig";
import { useNavigate } from "react-router-dom";

const Login = () => {

    const [id, setId] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await api.post("/login", {
                userid: id,
                password: password
            });

            navigate("/");

        } catch (e) {
            console.error(e);
            alert("아이디 또는 비밀번호가 일치하지 않습니다.");
            
            setId("");
            setPassword("");
        }
    };

    return (
        <>
            <div className="d-flex justify-content-center pt-5 pb-6">
                <Form onSubmit={handleSubmit} className="d-flex flex-column justify-content-center mt-4" style={{ width: "500px" }}>
                    <Form.Group className="mb-3">
                        <Form.Label>Id</Form.Label>
                        <Form.Control type="text" value={id} onChange={(e) => setId(e.target.value)} placeholder="아이디 입력"></Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="비밀번호 입력"></Form.Control>
                    </Form.Group>
                    <Button className="mt-3" variant="outline-info" type="submit">Login</Button>
                </Form>
            </div>
        </>
    );
}

export default Login;